import React from 'react';

import { LegacyPhoneNumberWidget } from './LegacyPhoneNumberWidget';
import { LegacyGetStartedWidget } from './LegacyGetStartedWidget';
import { DesktopPhoneNumberWidget } from './DesktopPhoneNumberWidget';
import { MobilePhoneNumberWidget } from './MobilePhoneNumberWidget';
import {
  GetStartedNoPhoneWidget,
  GetStartedNoPhoneWidgetProps
} from './GetStartedNoPhoneWidget';
import { GetStartedWidget, GetStartedWidgetProps } from './GetStartedWidget';
import { ViralLoopsWidget } from './ViralLoopsWidget';

import {
  NonContentfulWidgetProps,
  WidgetProps,
  ctaWidgetEnum,
  WaitlistEmailCaptureProps
} from './shared';

import { InBlockPhoneWidget } from './styles';

interface AllWidgetProps {
  type: ctaWidgetEnum;
  allProps:
    | GetStartedWidgetProps
    | WidgetProps
    | NonContentfulWidgetProps
    | WaitlistEmailCaptureProps;
}

export default function CtaWidgetMap({ type, allProps }: AllWidgetProps) {
  switch (type) {
    case ctaWidgetEnum.DESKTOP_PHONE_NUMBER_V1:
      return <LegacyPhoneNumberWidget {...allProps} />;

    case ctaWidgetEnum.INBLOCK_PHONE_NUMBER_V1:
      return <InBlockPhoneWidget {...allProps} />;

    case ctaWidgetEnum.DESKTOP_PHONE_NUMBER:
      return <DesktopPhoneNumberWidget {...(allProps as WidgetProps)} />;

    case ctaWidgetEnum.MOBILE_PHONE_NUMBER:
      return <MobilePhoneNumberWidget {...(allProps as WidgetProps)} />;

    case ctaWidgetEnum.GET_STARTED_V1:
      return <LegacyGetStartedWidget {...allProps} />;

    case ctaWidgetEnum.GET_STARTED_NO_PHONE:
      return (
        <GetStartedNoPhoneWidget
          {...(allProps as GetStartedNoPhoneWidgetProps)}
        />
      );

    case ctaWidgetEnum.WAITLIST_EMAIL_CAPTURE:
      return <ViralLoopsWidget {...(allProps as WaitlistEmailCaptureProps)} />;

    case ctaWidgetEnum.GET_STARTED:
    default:
      return <GetStartedWidget {...(allProps as GetStartedWidgetProps)} />;
  }
}
